<style lang="scss" scoped>
.blue {
  color: #173bcf;
}
.table {
  background: #fff;
  height: 400px;
  margin-top: 20px;
  position: relative;
}
.form {
  background: #f4f4f4;
  height: 350px;
  border: 1px solid #dcdfe6;
  padding: 20px;
  position: relative;
}
/deep/ {
  .el-input {
    width: 475px;
  }
  .el-input .el-input__count .el-input__count-inner {
    background: transparent;
  }
}
.gray {
  color: #6d7278;
  margin-left: 5px;
}
.btn {
  position: absolute;
  bottom: 100px;
  right: 50px;
}
.img {
  width: 300px;
  height: 300px;
}
.title {
  font-size: 20px;
}
.kong {
  color: #606266;
  i {
    font-size: 150px;
    color: #bdc7db;
  }
}
.flex {
  display: flex;
  .r {
    flex: 1;
    position: relative;
    > div {
      position: absolute;
      bottom: 20px;
      left: 0;
      width: 100%;
      border: 1px solid #dcdfe6;
    }
  }
}
.url {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  border-radius: 4px 4px 0 0;
  + div {
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background: #f5f7fa;
    color: #909399;
    border-radius: 0 0 4px 4px;
    span {
      font-size: 12px;
    }
  }
}
</style>

<template>
  <div>
    <alert>
      <div>1、公众号分为订阅号、服务号，根据微信公众平台的接口规则，不同类型的公众号可使用不同的功能；如果是认证的服务号则下面的全部功能均可使用！</div>
      <div>2、认证：在公众平台后台提交企业资料并向微信支付300元的认证费用并审核通过，叫公众号认证；如果公众号没有认证则只能使用下面的部分功能！</div>
      <div>3、该公众号（上海零动）是已认证的服务号，下面的全部功能均可使用！</div>
    </alert>
    <div class="clearfix">
      <el-button
        class="fl"
        type="primary"
        icon="el-icon-plus"
        @click="()=>{this.show = true}"
      >新建收款二维码</el-button>
      <a href class="fr blue" v-show="tableData.length">
        <i class="iconfont iconxiazai1"></i>下载表格
      </a>
    </div>
    <div class="table">
      <template v-if="tableData.length">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="date" label="收款名称"></el-table-column>
          <el-table-column prop="count" label="收款金额"></el-table-column>
          <el-table-column prop="new" label="累计收款"></el-table-column>
          <el-table-column label="收款明细">
            <template slot-scope="scope">
              <router-link class="blue" to="detail">查看明细</router-link>
            </template>
          </el-table-column>
          <el-table-column prop="cancel" label="收款二维码/链接">
            <template slot-scope="scope">
              <div class="blue pointer" @click="chakan">查看</div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="blue pointer">
                <i class="el-icon-delete"></i>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-else>
        <div class="kong center">
          <div class="alignc">
            <i class="iconfont iconkong"></i>
          </div>
          <div>
            创建收款码之前,请完成微信
            <router-link class="blue" to>支付配置</router-link>
          </div>
        </div>
      </template>
    </div>
    <el-dialog title="新建收款二维码" :visible.sync="show" width="800px">
      <div class="form">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
          <el-form-item label="收款名称" prop="name">
            <el-input v-model="form.name" maxlength="15" show-word-limit size="small"></el-input>
            <span class="gray">提交后不可修改</span>
          </el-form-item>
          <el-form-item label="收款类型">
            <el-radio-group v-model="form.type">
              <el-radio label="1">指定金额收款</el-radio>
              <el-radio label="2">自助收款</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="收款金额" v-show="form.type == 1" prop="count">
            <el-input v-model="form.count" size="small"></el-input>
            <span class="gray">单位:(元)</span>
          </el-form-item>
          <el-button class="btn" type="primary" @click="onSubmit('form')">生成</el-button>
        </el-form>
      </div>
    </el-dialog>
    <el-dialog title :visible.sync="show2" width="800px">
      <div class="title">
        收款二维码:
        <span class="blue">夏季内卖</span>
      </div>
      <div class="flex">
        <div>
          <img
            class="img"
            src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1558952841940&di=9219b7e340e37baa8435ad4189be191a&imgtype=0&src=http%3A%2F%2Fi6.hexunimg.cn%2F2014-01-15%2F161426168.jpg"
            alt
          />
          <div class="alignr">右键保存二维码图片</div>
        </div>
        <div class="r">
          <div>
            <div class="url">www.baidu.com</div>
            <div class="alignc">
              点击复制收款链接
              <span>(必须在微信客户端下访问)</span>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import utils from '@/utils.js';
export default {
  components: {},
  computed: {},
  watch: {
    'form.name': {
      handler(val, oldval) {
        let iLen = utils.getStringLength(val);
        console.log(iLen);
        if (iLen > 40) {
          this.form.name = oldval;
        }
      },
    },
  },
  data() {
    return {
      show: false,
      show2: false,
      tableData: [
        {
          date: '2019/05/24',
          count: 200,
          new: 60,
          old: 140,
          cancel: 4,
          id: 1,
        },
      ],
      form: {
        name: '',
        type: '1',
        count: '',
      },
      rules: {
        name: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入名称'));
              } else if (value.length > 15) {
                callback(new Error('长度超出范围'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
        count: [
          {
            validator: (rule, value, callback) => {
              if (this.form.type == 1 && !value) {
                callback(new Error('请输入金额'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    onSubmit(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.show = false;
        } else {
          return false;
        }
      });
    },
    chakan() {
      this.show2 = true;
    },
  },
};
</script>
